/* jb-cart.js — carrinho Jardim Brasil: frete por CEP, troca pelo kit, barra de frete grátis */
(function () {
  'use strict';
  if (window.__jbCartLoaded) return;
  window.__jbCartLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  var money = function (cents) { return brl.format((cents || 0) / 100); };

  /* CEP → UF (faixas dos Correios) */
  var UF = [
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'],
    [40000, 48999, 'BA'], [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'],
    [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'],
    [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'],
    [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [79000, 79999, 'MS'], [80000, 87999, 'PR'],
    [88000, 89999, 'SC'], [90000, 99999, 'RS']
  ];
  var UF_NAME = { SP: 'São Paulo', RJ: 'Rio de Janeiro', ES: 'Espírito Santo', MG: 'Minas Gerais', BA: 'Bahia', SE: 'Sergipe', PE: 'Pernambuco', AL: 'Alagoas', PB: 'Paraíba', RN: 'Rio Grande do Norte', CE: 'Ceará', PI: 'Piauí', MA: 'Maranhão', PA: 'Pará', AP: 'Amapá', AM: 'Amazonas', RR: 'Roraima', AC: 'Acre', DF: 'Distrito Federal', GO: 'Goiás', RO: 'Rondônia', TO: 'Tocantins', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', PR: 'Paraná', SC: 'Santa Catarina', RS: 'Rio Grande do Sul' };
  function ufFromCep(cep) {
    var n = parseInt(cep.slice(0, 5), 10);
    for (var i = 0; i < UF.length; i++) if (n >= UF[i][0] && n <= UF[i][1]) return UF[i][2];
    return '';
  }
  function maskCep(v) {
    v = (v || '').replace(/\D/g, '').slice(0, 8);
    return v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
  }
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var ratesCache = {};

  function setBusy(btn, on) {
    if (!btn) return;
    if (on) { btn.setAttribute('aria-busy', 'true'); btn.setAttribute('disabled', 'true'); }
    else { btn.removeAttribute('aria-busy'); btn.removeAttribute('disabled'); }
  }

  function findSummary(el) {
    var root = el.closest('hdt-cart-drawer, hdt-main-cart, .shopify-section') || document;
    return root.querySelector('[data-jb-summary]');
  }

  function updateSummary(summary, rate) {
    if (!summary) return;
    var total = parseInt(summary.dataset.total, 10) || 0;
    var val = summary.querySelector('[data-jb-ship-value]');
    var lab = summary.querySelector('[data-jb-ship-label]');
    var tot = summary.querySelector('[data-jb-total]');
    if (!rate) return;
    var cents = Math.round(parseFloat(rate.price) * 100) || 0;
    if (val) val.innerHTML = cents === 0 ? '<span class="jb-cart-summary__free">grátis</span>' : money(cents);
    if (lab) lab.textContent = rate.name ? '(' + rate.name.toLowerCase() + ')' : '';
    if (tot) tot.textContent = money(total + cents);
  }

  /* ---------------- frete por CEP ---------------- */
  var JbCartShipping = (function () {
    function C() { return Reflect.construct(HTMLElement, [], C); }
    C.prototype = Object.create(HTMLElement.prototype);
    C.prototype.constructor = C;

    C.prototype.connectedCallback = function () {
      var self = this;
      this.input = this.querySelector('[data-jb-cep-input]');
      this.btn = this.querySelector('[data-jb-cep-calc]');
      this.result = this.querySelector('[data-jb-cep-result]');
      if (!this.input || !this.btn) return;

      this.input.addEventListener('input', function () {
        self.input.value = maskCep(self.input.value);
        if (self.input.value.length === 9) self.calc();
      });
      this.input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.calc(); } });
      this.btn.addEventListener('click', function () { self.calc(); });

      var saved = store.get('jb_cep');
      if (saved && saved.length === 9) {
        this.input.value = saved;
        this.calc(true);
      }
    };

    C.prototype.calc = function (silent) {
      var self = this;
      var cep = maskCep(this.input.value);
      this.input.value = cep;
      if (cep.length !== 9) {
        if (!silent) this.showMsg('Digite um CEP com 8 números.', true);
        return;
      }
      var uf = ufFromCep(cep);
      if (!uf) { this.showMsg('CEP não encontrado. Confira os números.', true); return; }
      store.set('jb_cep', cep);

      var key = cep + '|' + (this.dataset.shippable || '');
      if (ratesCache[key]) { this.render(ratesCache[key], uf); return; }

      setBusy(this.btn, true);
      this.showMsg('Consultando as transportadoras…', false);
      var body = { shipping_address: { zip: cep.replace('-', ''), country: 'BR', province: uf } };
      fetch(ROOT + 'cart/shipping_rates.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (r.status === 202) return self.poll(6);
        return r.json();
      }).then(function (data) {
        var rates = (data && data.shipping_rates) || [];
        if (data && data.zip && !rates.length) throw new Error(Array.isArray(data.zip) ? data.zip.join(' ') : 'CEP inválido');
        ratesCache[key] = rates;
        self.render(rates, uf);
      }).catch(function (err) {
        console.error('[jb-cart] frete', err);
        self.showMsg('Não conseguimos calcular o frete agora. Tente de novo em instantes.', true);
      }).finally(function () { setBusy(self.btn, false); });
    };

    C.prototype.poll = function (tries) {
      var self = this;
      return new Promise(function (resolve, reject) {
        (function tick(n) {
          setTimeout(function () {
            fetch(ROOT + 'cart/async_shipping_rates.json', { headers: { Accept: 'application/json' } })
              .then(function (r) {
                if (r.status === 200) return r.json().then(resolve);
                if (n <= 1) return reject(new Error('timeout'));
                tick(n - 1);
              }).catch(reject);
          }, 900);
        })(tries);
      });
    };

    C.prototype.showMsg = function (text, isError) {
      if (!this.result) return;
      this.result.innerHTML = '<p class="jb-cart-cep__msg' + (isError ? ' is-error' : '') + '">' + text + '</p>';
    };

    C.prototype.render = function (rates, uf) {
      var self = this;
      if (!this.result) return;
      if (!rates.length) { this.showMsg('Ainda não entregamos nesse CEP.', true); return; }
      rates = rates.slice().sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
      var savedCode = store.get('jb_rate');
      var selected = rates.filter(function (r) { return r.code === savedCode; })[0] || rates[0];

      var html = '<p class="jb-cart-cep__place">Entrega para <b>' + (UF_NAME[uf] || uf) + '</b> · CEP ' + this.input.value + '</p><ul class="jb-cart-cep__rates" role="list">';
      rates.forEach(function (r, i) {
        var cents = Math.round(parseFloat(r.price) * 100);
        var days = '';
        if (r.delivery_days && r.delivery_days.length) {
          var a = r.delivery_days[0], b = r.delivery_days[1];
          days = (a === b || b == null) ? 'até ' + a + ' dia' + (a === 1 ? '' : 's') + ' úteis' : a + ' a ' + b + ' dias úteis';
        } else if (r.delivery_range && r.delivery_range.length) {
          days = 'previsão ' + r.delivery_range[0].split('-').reverse().slice(0, 2).join('/');
        }
        html += '<li class="jb-cart-cep__rate' + (r === selected ? ' is-selected' : '') + '" data-idx="' + i + '" role="button" tabindex="0">' +
          '<span class="jb-cart-cep__radio"></span>' +
          '<span><span class="jb-cart-cep__name">' + r.name + '</span>' + (days ? '<span class="jb-cart-cep__days">' + days + '</span>' : '') + '</span>' +
          '<span class="jb-cart-cep__price' + (cents === 0 ? ' is-free' : '') + '">' + (cents === 0 ? 'grátis' : money(cents)) + '</span></li>';
      });
      html += '</ul>';
      this.result.innerHTML = html;
      updateSummary(findSummary(this), selected);

      this.result.querySelectorAll('.jb-cart-cep__rate').forEach(function (li) {
        var pick = function () {
          self.result.querySelectorAll('.jb-cart-cep__rate').forEach(function (x) { x.classList.remove('is-selected'); });
          li.classList.add('is-selected');
          var r = rates[parseInt(li.dataset.idx, 10)];
          store.set('jb_rate', r.code || '');
          updateSummary(findSummary(self), r);
        };
        li.addEventListener('click', pick);
        li.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      });
    };
    return C;
  })();
  if (!customElements.get('jb-cart-shipping')) customElements.define('jb-cart-shipping', JbCartShipping);

  /* ---------------- trocar pelo kit ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jb-kit-swap]');
    if (!btn) return;
    e.preventDefault();
    var kitId = btn.getAttribute('data-jb-kit-swap');
    var remove = (btn.getAttribute('data-jb-remove') || '').split(',').filter(Boolean);
    setBusy(btn, true);
    document.dispatchEvent(new CustomEvent('theme:loading:doing'));
    var updates = {};
    remove.forEach(function (id) { updates[id] = 0; });
    var p = remove.length
      ? fetch(ROOT + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
      : Promise.resolve();
    p.then(function () {
      return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(kitId, 10), quantity: 1 }] }) });
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || j.message || 'erro'); });
      document.dispatchEvent(new CustomEvent('cart:reload'));
    }).catch(function (err) {
      console.error('[jb-cart] kit', err);
      setBusy(btn, false);
      var card = btn.closest('.jb-cart-ritual__card');
      if (card) {
        var m = card.querySelector('.jb-cart-cep__msg') || document.createElement('p');
        m.className = 'jb-cart-cep__msg is-error';
        m.style.gridColumn = '1 / -1';
        m.textContent = 'Não foi possível trocar pelo kit agora. Tente novamente.';
        card.appendChild(m);
      }
    }).finally(function () { document.dispatchEvent(new CustomEvent('theme:loading:done')); });
  });

  /* ---------------- barra de frete grátis ---------------- */
  function animateBars(scope) {
    (scope || document).querySelectorAll('[data-jb-bar-fill]').forEach(function (fill) {
      if (fill.dataset.animated) return;
      fill.dataset.animated = '1';
      var pct = fill.dataset.pct || '0';
      fill.style.transition = 'none';
      fill.style.width = '0%';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fill.style.transition = '';
          fill.style.width = pct + '%';
        });
      });
    });
  }
  function onRender() { animateBars(); }
  document.addEventListener('cart:drawer:render', onRender);
  document.addEventListener('cart:main:render', onRender);
  document.addEventListener('dialog:open', function () {
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    d.querySelectorAll('[data-jb-bar-fill]').forEach(function (f) { delete f.dataset.animated; });
    animateBars(d);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onRender);
  else onRender();

  /* contador do título do drawer acompanha o carrinho */
  document.addEventListener('cart:count:update', function (e) {
    var n = e && e.detail ? parseInt(e.detail.item_count != null ? e.detail.item_count : e.detail.count, 10) : NaN;
    if (isNaN(n)) return;
    document.querySelectorAll('[data-jb-cart-count]').forEach(function (el) {
      el.textContent = n ? '· ' + n + (n === 1 ? ' item' : ' itens') : '';
    });
  });
})();
